import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Accordion, AccordionDetails, AccordionSummary, Divider, Typography} from '@mui/material';
import {useState} from 'react';
import {useOrgMembers} from '../../../hooks/selectors';
import {type Organization} from '../../../types';
import StyledUsersTable from '../../StyledComponents/StyledUsersTable';

function OrganizationCardUserLarge(organization: Organization) {
  const users = [...useOrgMembers(organization.id)].sort((a, b) => {
    const aIsOwner = a.roles.includes('OrgOwner');
    const bIsOwner = b.roles.includes('OrgOwner');
    if (aIsOwner && !bIsOwner) {
      return -1;
    }
    if (!aIsOwner && bIsOwner) {
      return 1;
    }
    return 0;
  });
  const [expanded, setExpanded] = useState(true);

  const handleAccordionChange = (_: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  return users.length > 0 ? (
    <Accordion expanded={expanded} onChange={handleAccordionChange}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="members-content"
        id="members-header"
      >
        <Typography variant="h2">Members</Typography>
        <Divider sx={{my: 2}} />
      </AccordionSummary>
      <AccordionDetails>
        <StyledUsersTable users={users} />
      </AccordionDetails>
    </Accordion>
  ) : (
    <Typography>No users</Typography>
  );
}

export default OrganizationCardUserLarge;
